(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["danstack-video"] && !Shopify.designMode) return;
  try {
    
var abvShoppableVideoInit = function (sectionEl) {
  var sectionId = sectionEl.getAttribute('data-abv-section-id');

  var cards = sectionEl.querySelectorAll('[data-video-card][data-has-video="true"]');
  var currentVideo = null;
  var currentIcon = null;
  var hasIO = 'IntersectionObserver' in window;

  // Card auto-previews are suspended while the reels overlay is open so the
  // cards behind it stop decoding video (IntersectionObserver can't detect
  // that the overlay is covering them). State + helpers live here so
  // openReels/closeReels below can call them; the preview observer itself is
  // set up near the bottom of this script.
  var previewsSuspended = false;

  function suspendCardPreviews() {
    previewsSuspended = true;
    cards.forEach(function (card) {
      var v = card.querySelector('.video-card__video');
      if (v) v.pause();
    });
  }

  function resumeCardPreviews() {
    previewsSuspended = false;
    cards.forEach(function (card) {
      if (!card.hasAttribute('data-preview-visible')) return;
      var v = card.querySelector('.video-card__video');
      // Only restart videos that are in muted-preview mode — never auto-play
      // over one the customer had playing inline with sound (fallback path).
      if (v && v.muted) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }

  // Keeps the THEME's own cart drawer/notification from sliding open while
  // the reel modal is up — this section has its own cart panel, so a theme
  // drawer appearing over it is pure distraction. Neutralising open() is the
  // only lever from outside: Dawn-family renderContents() calls it as a
  // hardcoded side effect, and other themes open theirs from the standard
  // cart events. Both <cart-drawer> and <cart-notification> are patched
  // since a theme may ship either. Cart data is still sent and refreshed
  // exactly as before — only the theme's panel stays closed. No-op when the
  // modal is closed, so outside it the theme behaves normally.
  function withThemeCartClosed(run) {
    if (!reelsOverlay || reelsOverlay.hidden) return run();

    var restores = [];
    [document.querySelector('cart-drawer'), document.querySelector('cart-notification')].forEach(function (el) {
      if (!el || typeof el.open !== 'function') return;
      var originalOpen = el.open;
      el.open = function () {};
      restores.push(function () { el.open = originalOpen; });
    });
    // Deferred by a tick because renderContents() schedules its own open()
    // with setTimeout — releasing synchronously would hand the real method
    // back before that deferred call lands on the no-op.
    var release = function () {
      if (!restores.length) return;
      var pending = restores;
      restores = [];
      setTimeout(function () { pending.forEach(function (fn) { fn(); }); }, 0);
    };
    var result;
    try {
      result = run();
    } catch (err) {
      release();
      throw err;
    }
    if (result && typeof result.then === 'function') {
      result.then(release, release);
    } else {
      release();
    }
    return result;
  }

  function stopCurrentVideo() {
    if (currentVideo) {
      currentVideo.pause();
      // Do NOT reset currentTime, so frame stays where paused
    }
    if (currentIcon) currentIcon.style.display = 'flex';
    currentVideo = null;
    currentIcon = null;
  }

  // Attaches a card's video <source> (from its data-src) if it hasn't been
  // already — the preview loader below normally does this ahead of time as
  // a card approaches the viewport, but anything that's about to call
  // .play() on a card video goes through this first as a safety net, so
  // playback is never silently a no-op just because that hadn't fired yet.
  // Applies a deferred poster (see data-poster in the markup above). Safe to
  // call any number of times.
  function applyCardPoster(video) {
    if (!video || !video.dataset.poster) return;
    if (video.dataset.poster !== '') video.poster = video.dataset.poster;
    delete video.dataset.poster;
  }

  function attachCardVideoSource(video) {
    applyCardPoster(video);
    if (!video || !video.dataset.src) return;
    var source = document.createElement('source');
    source.src = video.dataset.src;
    source.type = 'video/mp4';
    video.appendChild(source);
    delete video.dataset.src;
    video.load();
  }

  function toggleCardVideo(card) {
    var video = card.querySelector('.video-card__video');
    var icon = card.querySelector('[data-play-icon]');
    if (!video) return;
    attachCardVideoSource(video);

    // If this card is already active:
    if (currentVideo === video) {
      if (video.paused) {
        video.muted = false;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        if (icon) icon.style.display = 'none';
      } else {
        video.pause();
        if (icon) icon.style.display = 'flex';
      }
      return;
    }
    // New card: stop any other
    stopCurrentVideo();

    video.muted = false;
    var playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {
        // Autoplay-with-sound blocked in this browser; fall back to muted.
        video.muted = true;
        video.play();
      });
    }
    if (icon) icon.style.display = 'none';

    currentVideo = video;
    currentIcon = icon;
  }

  // ---- Reels: full-screen on mobile, centered video+panel modal on desktop ----
  // Looked up from the document (not sectionEl) because the overlay is a
  // sibling of sectionEl in the markup, not a descendant of it.
  var reelsOverlay = document.querySelector('[data-reels-overlay="' + sectionId + '"]');
  var reelsTrack = reelsOverlay ? reelsOverlay.querySelector('[data-reels-track]') : null;
  var reelsClose = reelsOverlay ? reelsOverlay.querySelector('[data-reels-close]') : null;
  var reelsPrevBtn = reelsOverlay ? reelsOverlay.querySelector('[data-reels-prev]') : null;
  var reelsNextBtn = reelsOverlay ? reelsOverlay.querySelector('[data-reels-next]') : null;
  var desktopPanel = reelsOverlay ? reelsOverlay.querySelector('[data-desktop-panel]') : null;
  var desktopPanelList = reelsOverlay ? reelsOverlay.querySelector('[data-desktop-panel-list]') : null;
  var desktopPanelDetail = reelsOverlay ? reelsOverlay.querySelector('[data-desktop-panel-detail]') : null;

  // Move the overlay to be a direct child of <body>. If any ancestor of the
  // section applies a CSS transform (common in scroll-reveal animations),
  // position: fixed on a nested element stops being relative to the
  // viewport, which can make the overlay render off-screen or clipped.
  if (reelsOverlay && reelsOverlay.parentNode !== document.body) document.body.appendChild(reelsOverlay);
  var videoCards = Array.prototype.slice.call(cards);
  var reelsActiveIndex = -1;
  var reelsPrevBodyOverflow = '';
  var reelsSourceObserver = null;
  var reelsActiveObserver = null;
  var reelsHistoryPushed = false;
  // Decided once per reels-open (see openReels): true when the modal opened
  // on a desktop-width viewport, so the video+side-panel layout and desktop
  // panel content get built instead of the mobile full-screen carousel.
  var reelsDesktopMode = false;

  // ---- Reel product card / Add to Cart sheet ----
  var productPanel = reelsOverlay ? reelsOverlay.querySelector('[data-product-panel]') : null;
  var productPanelSheet = productPanel ? productPanel.querySelector('[data-product-panel-sheet]') : null;
  var productPanelContent = productPanel ? productPanel.querySelector('[data-product-panel-content]') : null;
  var productPanelClose = productPanel ? productPanel.querySelector('[data-product-panel-close]') : null;
  var productPanelBackdrop = productPanel ? productPanel.querySelector('[data-product-panel-backdrop]') : null;
  var productToast = reelsOverlay ? reelsOverlay.querySelector('[data-product-toast]') : null;
  var productToastText = productToast ? productToast.querySelector('[data-product-toast-text]') : null;
  var productToastLink = productToast ? productToast.querySelector('[data-product-toast-link]') : null;
  var productToastTimer = null;

  // ---- Our own cart panel (built from /cart.js, not the theme's drawer) ----
  var cartPanel = reelsOverlay ? reelsOverlay.querySelector('[data-cart-panel]') : null;
  var cartBody = cartPanel ? cartPanel.querySelector('[data-cart-body]') : null;
  var cartBackBtn = cartPanel ? cartPanel.querySelector('[data-cart-back]') : null;
  var cartFooter = cartPanel ? cartPanel.querySelector('[data-cart-footer]') : null;
  var cartVideoWasPlaying = false;

  function abvFormatMoney(cents) {
    // Cart API always returns integer cents; Shopify exposes the store's
    // own money format string, which we honour so currency/format matches
    // the rest of the storefront rather than guessing a locale.
    var amount = (Number(cents) || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return amount.toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  // Updates every cart-count badge this section rendered (reel buttons and
  // any sticky Add to Cart bars currently on screen).
  function updateCartCountBadges(itemCount) {
    var badges = document.querySelectorAll('[data-reels-overlay="' + sectionId + '"] [data-cart-count]');
    badges.forEach(function (badge) {
      badge.textContent = itemCount;
      badge.hidden = !itemCount;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  function refreshCartCount() {
    return fetchCart()
      .then(function (cart) {
        updateCartCountBadges(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  function renderCartPanel(cart) {
    if (!cartBody) return;
    cartBody.innerHTML = '';

    if (!cart || !cart.items || !cart.items.length) {
      var empty = document.createElement('div');
      empty.className = 'abv-cart-panel__empty';
      empty.textContent = 'Your cart is empty.';
      cartBody.appendChild(empty);
      renderCheckoutButton(null);
      return;
    }
    cart.items.forEach(function (item, idx) {
      var line = document.createElement('div');
      line.className = 'abv-cart-line';

      var img = document.createElement('img');
      img.className = 'abv-cart-line__img';
      img.loading = 'lazy';
      img.alt = item.product_title || '';
      if (item.image) img.src = item.image;
      line.appendChild(img);

      var info = document.createElement('div');
      info.className = 'abv-cart-line__info';

      var title = document.createElement('div');
      title.className = 'abv-cart-line__title';
      title.textContent = item.product_title || item.title || '';
      info.appendChild(title);

      // variant_title is null for single-variant products — skip the line
      // entirely in that case rather than rendering an empty row.
      if (item.variant_title) {
        var variant = document.createElement('div');
        variant.className = 'abv-cart-line__variant';
        variant.textContent = item.variant_title;
        info.appendChild(variant);
      }
      var bottom = document.createElement('div');
      bottom.className = 'abv-cart-line__bottom';

      var qty = document.createElement('div');
      qty.className = 'abv-cart-qty';
      var minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'abv-cart-qty__btn';
      minus.textContent = '−';
      minus.setAttribute('aria-label', 'Decrease quantity');
      var qtyVal = document.createElement('span');
      qtyVal.className = 'abv-cart-qty__value';
      qtyVal.textContent = item.quantity;
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'abv-cart-qty__btn';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'Increase quantity');
      qty.appendChild(minus);
      qty.appendChild(qtyVal);
      qty.appendChild(plus);
      bottom.appendChild(qty);

      var price = document.createElement('div');
      price.className = 'abv-cart-line__price';
      price.textContent = abvFormatMoney(item.line_price);
      bottom.appendChild(price);

      info.appendChild(bottom);
      line.appendChild(info);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'abv-cart-line__remove';
      remove.setAttribute('aria-label', 'Remove item');
      remove.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M6 7h12v13a1 1 0 01-1 1H7a1 1 0 01-1-1V7zm3-3h6l1 2h4v2H4V6h4l1-2z"></path></svg>';
      line.appendChild(remove);

      // Cart line index is 1-based in /cart/change.js. Using the line
      // number (not variant id) so two lines of the same variant with
      // different properties stay independently editable.
      var lineNumber = idx + 1;
      minus.addEventListener('click', function () { changeCartLine(lineNumber, item.quantity - 1); });
      plus.addEventListener('click', function () { changeCartLine(lineNumber, item.quantity + 1); });
      remove.addEventListener('click', function () { changeCartLine(lineNumber, 0); });

      cartBody.appendChild(line);
    });
    renderCheckoutButton(cart);
  }

  // Builds the Checkout button FRESH, in place, every time the panel
  // renders — and only ever while the panel is already visible.
  //
  // This is the whole mechanism for supporting third-party checkout
  // accelerators without writing a single line of code specific to any of
  // them. There are TWO families in the wild and the button has to satisfy
  // both, because they detect a checkout button in completely different
  // ways.
  //
  // 1. SCANNERS (GoKwik, Shiprocket, Fastrr, ...). They run a
  //    MutationObserver over document.body looking for newly added,
  //    VISIBLE buttons whose TEXT reads "checkout"; when they find one
  //    they clone it, tag it as theirs, and intercept the clone's clicks.
  //    A button that merely sits in the markup from page load — inside our
  //    overlay, which starts hidden — is skipped by those scanners (they
  //    explicitly ignore invisible elements) and never claimed. That is
  //    why the button is rebuilt here on every render, while the panel is
  //    already open, instead of living in the overlay's markup.
  //
  // 2. DELEGATORS (Razorpay Magic Checkout, ...). These never touch the
  //    DOM at all. They put ONE capture-phase click listener on document
  //    and test each click's target against a fixed allowlist of CSS
  //    selectors describing what a Shopify checkout button looks like.
  //    Razorpay's list (magic-shopify.js) is:
  //      form[action="/cart"] [type="submit"][name="checkout"]
  //      form[action="/cart"] button[name="checkout"]
  //      button[type="submit"][name="checkout"]
  //      button[type="button"][name="checkout"]     <- the one we match
  //      form[action="/cart"] a[href="/checkout"]
  //    Every single entry is keyed on name="checkout", and button TEXT is
  //    irrelevant to them. So a button reading "Checkout — 999" with no
  //    name attribute is completely invisible to this whole family: the
  //    click fell through to our own listener and went to /checkout, which
  //    is standard Shopify checkout with Razorpay merely offered as a
  //    payment method — NOT Magic Checkout. Hence btn.name below.
  //
  // No detection or coordination is needed on our side, because neither
  // family can double-fire alongside our own listener:
  //   - scanner present    -> it clones our button, and cloneNode() does
  //                           not carry over addEventListener handlers, so
  //                           ours is dropped with the original and only
  //                           its handler runs
  //   - delegator present  -> it catches the click in the CAPTURE phase on
  //                           document and stops propagation, so the event
  //                           never reaches our listener on the button
  //   - neither            -> nothing touches the button, our own listener
  //                           runs and goes to /checkout
  function renderCheckoutButton(cart) {
    if (!cartFooter) return;
    cartFooter.innerHTML = '';

    var hasItems = !!(cart && cart.items && cart.items.length);

    var btn = document.createElement('button');
    btn.type = 'button';
    // What the delegator family keys on (see above). Inert everywhere
    // else: this button is not inside a <form>, so the name is never
    // submitted anywhere and nothing but those matchers ever reads it.
    btn.name = 'checkout';
    btn.className = 'abv-cart-checkout';
    btn.textContent = hasItems
      ? 'Checkout — ' + abvFormatMoney(cart.total_price)
      : 'Checkout';
    btn.disabled = !hasItems;
    btn.addEventListener('click', goToCheckout);

    cartFooter.appendChild(btn);
  }

  // Writes the item count into the theme's own header cart badge. Needed
  // on every path: Dawn's onCartUpdate() only re-renders the cart drawer /
  // cart page sections, never the separate cart-icon-bubble section, so
  // without this the header count goes stale after a quantity change.
  // Uses the cart we already have rather than re-fetching /cart.js.
  function updateThemeCartCount(cart) {
    // Preferred path: re-render the theme's own cart-icon-bubble section
    // from HTML Shopify already returned with this same request (we always
    // ask for that section below), replicating exactly what Dawn's own
    // updateQuantity does. This preserves the theme's real markup —
    // accessibility spans, and the empty-cart state where Dawn renders no
    // bubble at all rather than a literal "0".
    var bubbleHost = document.getElementById('cart-icon-bubble');
    var bubbleHtml = cart.sections && cart.sections['cart-icon-bubble'];
    if (bubbleHost && bubbleHtml) {
      try {
        var fresh = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
        if (fresh) {
          (bubbleHost.querySelector('.shopify-section') || bubbleHost).innerHTML = fresh.innerHTML;
          return;
        }
      } catch (err) {}
    }
    // Fallback for themes without a cart-icon-bubble section: best-effort
    // text update on the common count-badge selectors.
    ['.cart-count-bubble', '.cart-count', '.cart-link__bubble'].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });
  }

  // Tells the HOST THEME its cart changed, using whichever contract that
  // theme implements, and reports back whether a theme-owned cart UI
  // actually took responsibility for refreshing its line items.
  //
  // Why this exists: quantity-change / remove is a different contract from
  // add-to-cart. <cart-notification> / <cart-drawer> and their
  // renderContents() belong to the ADD flow; in Dawn-family themes the
  // line items are owned by <cart-items> / <cart-drawer-items>, which
  // refresh themselves via onCartUpdate(). Driving the add-flow element
  // for a change either renders the wrong thing (cart-notification tries
  // to render an "added product" popup for a cart with no added product)
  // or leaves the real line items stale.
  function notifyThemeCartUpdated(cart) {
    var handled = false;

    // Horizon and any Shopify standard-events theme listen for this on
    // document (Horizon's cart-drawer.js binds StandardEvents.cartLinesUpdate
    // === 'shopify:cart:lines-update'). Inert on themes that don't listen,
    // so it's dispatched unconditionally.
    try {
      document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', {
        bubbles: true,
        detail: { cart: cart }
      }));
    } catch (err) {}

    var itemEls = document.querySelectorAll('cart-items, cart-drawer-items');
    if (!itemEls.length) return handled;

    var hasSubscriber = false;
    itemEls.forEach(function (el) {
      // Newer Dawn stores its pubsub unsubscribe fn here once subscribed.
      if (typeof el.cartUpdateUnsubscriber === 'function') hasSubscriber = true;
    });
    if (hasSubscriber && typeof window.publish === 'function') {
      // Newer Dawn: publishing IS the theme's own contract — its subscriber
      // refetches and swaps in its own fresh sections. The source must not
      // be 'cart-items', which that subscriber deliberately ignores (that's
      // how Dawn avoids reacting to updates it made itself).
      try {
        window.publish('cart-update', { source: 'abv-video-cart', cartData: cart });
        handled = true;
      } catch (err) {}
    }
    if (!handled) {
      // Older Dawn publishes cart-update but never subscribes to it, so
      // nothing above refreshed the line items — drive the theme's own
      // refresh method directly instead.
      itemEls.forEach(function (el) {
        if (typeof el.onCartUpdate === 'function') {
          try {
            el.onCartUpdate();
            handled = true;
          } catch (err) {}
        }
      });
    }
    return handled;
  }

  function changeCartLine(lineNumber, quantity) {
    // Same theme-notify approach as legacyAddToCart: without this, the
    // change only updates Shopify's server-side cart and OUR panel — the
    // theme's own cart UI (header badge, drawer contents) kept showing
    // stale data until a full page refresh.
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var canRenderNatively = !!(cartEl && typeof cartEl.getSectionsToRender === 'function' && typeof cartEl.renderContents === 'function');

    var body = { line: lineNumber, quantity: Math.max(0, quantity) };
    var sectionIds = canRenderNatively
      ? cartEl.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    // Always ask for the header count section, even on themes with no
    // add-flow element — updateThemeCartCount uses it, and requesting a
    // section a theme doesn't have is harmless (Shopify just omits it).
    if (sectionIds.indexOf('cart-icon-bubble') === -1) sectionIds.push('cart-icon-bubble');
    body.sections = sectionIds;
    body.sections_url = window.location.pathname;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartPanel(cart);
        updateCartCountBadges(cart.item_count);
        updateThemeCartCount(cart);

        // Dawn keeps this class on the drawer/notification wrapper in sync
        // with emptiness itself during its own updates; mirror that here so
        // an empty-cart state doesn't keep rendering as though it has items.
        if (cartEl) cartEl.classList.toggle('is-empty', cart.item_count === 0);

        var themeHandled = notifyThemeCartUpdated(cart);
        if (themeHandled) return;

        // No theme-owned line-item UI took the update (non-Dawn-family
        // theme). Fall back to the previous behavior: drive the add-flow
        // element's own renderer, then the generic badge/event fallback.
        if (canRenderNatively && cart.sections) {
          // The customer is inside our own cart panel here; the theme's
          // drawer sliding open underneath it would be plain wrong.
          withThemeCartClosed(function () {
            try { cartEl.renderContents(cart); } catch (err) {}
          });
        } else {
          refreshCartUIFallback();
        }
      })
      .catch(function () {
        showProductToast('Could not update cart', false);
      });
  }

  function openCartPanel() {
    if (!cartPanel) return;

    // Pause the reel behind the panel, remembering whether it was actually
    // playing so closing doesn't force-resume a video the customer had
    // deliberately paused themselves.
    var activeSlide = reelsTrack ? reelsTrack.querySelectorAll('.abv-reels-slide')[reelsActiveIndex] : null;
    var activeVideo = activeSlide ? activeSlide.querySelector('video') : null;
    cartVideoWasPlaying = !!(activeVideo && !activeVideo.paused);
    if (activeVideo) activeVideo.pause();

    cartPanel.hidden = false;
    if (cartBody) cartBody.scrollTop = 0;

    fetchCart()
      .then(function (cart) {
        renderCartPanel(cart);
        updateCartCountBadges(cart.item_count);
      })
      .catch(function () {
        renderCartPanel(null);
      });
  }

  function closeCartPanel() {
    if (!cartPanel) return;
    cartPanel.hidden = true;

    if (cartVideoWasPlaying) {
      var activeSlide = reelsTrack ? reelsTrack.querySelectorAll('.abv-reels-slide')[reelsActiveIndex] : null;
      var activeVideo = activeSlide ? activeSlide.querySelector('video') : null;
      if (activeVideo) {
        var p = activeVideo.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    cartVideoWasPlaying = false;
  }

  // Only ever reached when NO checkout accelerator claimed our button (see
  // renderCheckoutButton) — i.e. a plain Shopify store — so going straight
  // to native checkout is the correct behavior here.
  function goToCheckout() {
    window.location.href = '/checkout';
  }

  if (cartBackBtn) cartBackBtn.addEventListener('click', closeCartPanel);

  function showProductToast(message, showViewCartLink) {
    if (!productToast) return;
    if (productToastText) productToastText.textContent = message || 'Added to cart';
    if (productToastLink) productToastLink.style.display = showViewCartLink ? '' : 'none';
    productToast.classList.add('abv-visible');
    if (productToastTimer) clearTimeout(productToastTimer);
    productToastTimer = setTimeout(function () {
      productToast.classList.remove('abv-visible');
    }, 3000);
  }

  // Generic fallback for themes without a <cart-notification>/<cart-drawer>
  // element (see addToCartAndNotify below): best-effort badge update + common
  // event names, plus the toast's "View Cart" link as a guaranteed backstop.
  // Only touches selectors confirmed to be small count elements, never a
  // whole icon/section wrapper (overwriting those would destroy the icon).
  function refreshCartUIFallback() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        [
          '[data-cart-count]',
          '.cart-count-bubble',
          '.cart-count',
          '.cart-link__bubble'
        ].forEach(function (selector) {
          document.querySelectorAll(selector).forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
        ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
        });
        return cart;
      })
      .catch(function () {});
  }

  // Three-tier waterfall, checked in this specific order, so this section
  // works correctly no matter what theme it's installed in:
  //
  // 1) Dawn-family native rendering (verified against this theme's own
  //    cart-drawer.js / cart-notification.js / product-form.js / global.js):
  //    find a <cart-notification> or <cart-drawer> element exposing
  //    getSectionsToRender()/renderContents(), POST a FormData body with
  //    "sections" as a comma-joined string + "sections_url", then call
  //    that element's renderContents() directly. This is EXACTLY what the
  //    theme's own native "Add to Cart" buttons already do — no dependency
  //    on any event listener existing, so it's the most reliable path
  //    whenever it's available. Checked first because most Shopify stores
  //    are still on this Dawn-family pattern.
  // 2) Shopify's standard cross-theme storefront actions (Spring '26+,
  //    shopify.dev/docs/apps/build/online-store/standard-events-and-actions),
  //    used only when tier 1's concrete cart element isn't found. Confirmed
  //    against Shopify's own Horizon theme: window.Shopify.actions is
  //    injected on essentially every storefront, but only themes actually
  //    built around it (like Horizon) have listeners that react to the
  //    shopify:cart:lines-update event it fires — calling it on a Dawn-family
  //    theme "succeeds" with nothing visibly updating, which is exactly why
  //    tier 1 is tried first instead of this. Never combined with tier 1 in
  //    the same flow — using both together caused a rendering conflict.
  // 3) Generic fallback (refreshCartUIFallback): best-effort count-badge
  //    update plus a guaranteed on-page toast, for any theme tier 1 and 2
  //    both miss.
  function legacyAddToCart(variantId) {
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var canRenderNatively = !!(cartEl && typeof cartEl.getSectionsToRender === 'function' && typeof cartEl.renderContents === 'function');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (canRenderNatively) {
      formData.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
    }
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    return fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function (cart) {
        if (canRenderNatively && cart.sections) {
          // Defensive: some Dawn-family themes set an "is-empty" class on
          // the cart element while the cart is empty and rely on their own
          // renderContents() to clear it on the first add — if that theme's
          // implementation misses it, CSS like ".is-empty .cart__contents"
          // can leave a freshly-added item invisible in the drawer. Clearing
          // it here too costs nothing on themes that already do it right.
          cartEl.classList.remove('is-empty');

          // Contents still render (so the drawer is correct when the
          // customer opens it later); it just never becomes visible over
          // the modal. See withThemeCartClosed.
          withThemeCartClosed(function () { cartEl.renderContents(cart); });

          return cart;
        }
        return refreshCartUIFallback();
      });
  }

  function addToCartAndNotify(variantId) {
    var dawnCartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var hasDawnCartApi = !!(dawnCartEl && typeof dawnCartEl.getSectionsToRender === 'function' && typeof dawnCartEl.renderContents === 'function');

    if (hasDawnCartApi) return legacyAddToCart(variantId);

    if (window.Shopify && window.Shopify.actions && typeof window.Shopify.actions.updateCart === 'function') {
      // Wrapped because updateCart() fires the standard cart events, and a
      // theme listening to those can open its own drawer in response. The
      // call is async, so the suppression is held until it settles rather
      // than released on the next tick. The events themselves still fire
      // untouched, so the theme's badge counts and any other cart listeners
      // keep working exactly as before — only the panel stays closed.
      return withThemeCartClosed(function () {
        return window.Shopify.actions.updateCart({
          lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }]
        });
      })
        .then(function (result) {
          if (result && result.userErrors && result.userErrors.length) {
            throw new Error(result.userErrors[0].message || 'Add to cart failed');
          }
          return result;
        })
        .catch(function () {
          // No Dawn-family element to fall back to here (that was already
          // ruled out above) — drop to the generic badge/toast fallback
          // instead of leaving the customer with an unrecoverable error.
          return refreshCartUIFallback();
        });
    }
    return refreshCartUIFallback();
  }

  // Wires Add to Cart + gallery-dot tracking on a rendered product detail
  // node. Shared by the mobile bottom sheet and the desktop side panel so
  // both stay in sync with the same behavior instead of duplicating it.

  // ---- Full-screen image lightbox — one overlay per section instance,
  // built lazily on first use and reused for every gallery afterward. ----
  var abvLightboxEl = null;
  var abvLightboxImages = [];
  var abvLightboxIndex = 0;

  function ensureLightbox() {
    if (abvLightboxEl) return abvLightboxEl;

    var overlay = document.createElement('div');
    overlay.className = 'abv-lightbox';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="abv-lightbox__dots" data-lightbox-dots></div>' +
      '<div class="abv-lightbox__stage"><img class="abv-lightbox__img" data-lightbox-img alt=""></div>' +
      '<div class="abv-lightbox__controls">' +
        '<button type="button" class="abv-lightbox__nav" data-lightbox-prev aria-label="Previous image">&#8249;</button>' +
        '<button type="button" class="abv-lightbox__close" data-lightbox-close aria-label="Close">&times;</button>' +
        '<button type="button" class="abv-lightbox__nav" data-lightbox-next aria-label="Next image">&#8250;</button>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.querySelector('[data-lightbox-close]').addEventListener('click', closeImageLightbox);
    overlay.querySelector('[data-lightbox-prev]').addEventListener('click', function () {
      abvLightboxIndex = (abvLightboxIndex - 1 + abvLightboxImages.length) % abvLightboxImages.length;
      renderLightbox();
    });
    overlay.querySelector('[data-lightbox-next]').addEventListener('click', function () {
      abvLightboxIndex = (abvLightboxIndex + 1) % abvLightboxImages.length;
      renderLightbox();
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeImageLightbox();
    });
    abvLightboxEl = overlay;
    return overlay;
  }

  function renderLightbox() {
    var overlay = ensureLightbox();
    overlay.querySelector('[data-lightbox-img]').src = abvLightboxImages[abvLightboxIndex];

    var dotsEl = overlay.querySelector('[data-lightbox-dots]');
    dotsEl.innerHTML = '';
    if (abvLightboxImages.length > 1) {
      abvLightboxImages.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'abv-lightbox__dot' + (i === abvLightboxIndex ? ' abv-active' : '');
        dotsEl.appendChild(dot);
      });
    }
    var multi = abvLightboxImages.length > 1;
    overlay.querySelector('[data-lightbox-prev]').style.display = multi ? '' : 'none';
    overlay.querySelector('[data-lightbox-next]').style.display = multi ? '' : 'none';
  }

  function openImageLightbox(images, startIndex) {
    if (!images || !images.length) return;
    abvLightboxImages = images;
    abvLightboxIndex = startIndex || 0;
    renderLightbox();
    ensureLightbox().hidden = false;
  }

  function closeImageLightbox() {
    if (abvLightboxEl) abvLightboxEl.hidden = true;
  }

  function wireProductDetail(container, onAddSuccess) {
    if (container._galleryObserver) {
      container._galleryObserver.disconnect();
      container._galleryObserver = null;
    }
    var addBtn = container.querySelector('[data-reel-addtocart]');

    // Wrap Add to Cart in a sticky bar (with its own cart button) so it
    // stays pinned to the bottom while the detail scrolls. Guarded against
    // double-wrapping, since wireProductDetail runs again on re-render.
    //
    // Moved to the END of container (after the description etc.), not left
    // where the button originally sat. position:sticky only keeps an
    // element from scrolling BELOW the visible area once it reaches that
    // point — an element sitting mid-content (its original position,
    // between price and description) scrolls up and away like anything
    // else. Only an element whose natural position is at the very end of
    // the scrollable content stays pinned to the bottom for the whole
    // scroll, which is the actual "always visible" behavior wanted here.
    if (addBtn && !addBtn.closest('.abv-sticky-atc')) {
      var stickyBar = document.createElement('div');
      stickyBar.className = 'abv-sticky-atc';
      container.appendChild(stickyBar);
      stickyBar.appendChild(addBtn);

      var stickyCartBtn = document.createElement('button');
      stickyCartBtn.type = 'button';
      stickyCartBtn.className = 'abv-sticky-atc__cart';
      stickyCartBtn.setAttribute('aria-label', 'Open cart');
      stickyCartBtn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4V3a1 1 0 011-1h8a1 1 0 011 1v1h3a1 1 0 011 1v15a2 2 0 01-2 2H5a2 2 0 01-2-2V5a1 1 0 011-1h3zm2 0h6V4H9zm-4 2v14h14V6H5z"></path></svg>' +
        '<span class="abv-cart-count" data-cart-count hidden>0</span>';
      stickyCartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openCartPanel();
      });
      stickyBar.appendChild(stickyCartBtn);

      // Populate this freshly created badge with the current count.
      refreshCartCount();
    }
    // Listener attached even when the button starts disabled (sold-out
    // first variant) — a disabled button never fires click anyway, and
    // this way it works immediately once the variant picker re-enables it.
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        // Keep this click fully contained. Some themes/apps attach a global
        // document-level listener that matches any "add to cart"-looking
        // button by class or label and runs their own handler — often a
        // real form submit or navigation — which would reload the page out
        // from under our AJAX add. preventDefault + stopPropagation makes
        // sure only our handler ever sees this click.
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        addBtn.disabled = true;
        var variantId = addBtn.getAttribute('data-variant-id');
        addToCartAndNotify(variantId)
          .then(function () {
            showProductToast('Added to cart', true);
            addBtn.disabled = false;
            refreshCartCount();
            if (onAddSuccess) onAddSuccess();
          })
          .catch(function () {
            addBtn.disabled = false;
            showProductToast('Could not add to cart', false);
          });
      });
    }
    // Variant picker — repoints Add to Cart at the chosen variant and
    // refreshes the shown price/availability. Everything it needs is on
    // the <option> data-attributes, so no extra fetch is involved.
    var variantSelect = container.querySelector('[data-variant-select]');
    if (variantSelect && addBtn) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        if (!opt) return;
        var available = opt.getAttribute('data-available') === 'true';
        var saleEl = container.querySelector('.abv-product-panel__price-sale');
        var compareEl = container.querySelector('.abv-product-panel__price-compare');

        addBtn.setAttribute('data-variant-id', opt.value);
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
        if (saleEl) saleEl.textContent = opt.getAttribute('data-price');
        if (compareEl) compareEl.textContent = opt.getAttribute('data-compare') || '';
      });
    }
    var galleryTrack = container.querySelector('.abv-product-gallery__track');
    var dots = container.querySelectorAll('.abv-product-gallery__dot');
    if (galleryTrack && dots.length > 1) {
      var gallerySlides = galleryTrack.querySelectorAll('.abv-product-gallery__slide');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            var idx = Array.prototype.indexOf.call(gallerySlides, entry.target);
            dots.forEach(function (dot, i) {
              dot.classList.toggle('abv-active', i === idx);
            });
          }
        });
      }, { root: galleryTrack, threshold: [0, 0.6, 1] });
      gallerySlides.forEach(function (s) { observer.observe(s); });
      container._galleryObserver = observer;
    }
    var galleryImgs = container.querySelectorAll('.abv-product-gallery__slide img');
    if (galleryImgs.length) {
      var lightboxSrcs = Array.prototype.map.call(galleryImgs, function (img) { return img.src; });
      galleryImgs.forEach(function (img, idx) {
        img.addEventListener('click', function (e) {
          e.stopPropagation();
          openImageLightbox(lightboxSrcs, idx);
        });
      });
    }
  }

  // ---- Mobile bottom sheet (single product detail, dismissible) ----
  function closeProductPanel() {
    if (productPanel) productPanel.classList.remove('abv-open');
    if (productPanelContent && productPanelContent._galleryObserver) {
      productPanelContent._galleryObserver.disconnect();
      productPanelContent._galleryObserver = null;
    }
  }

  function openProductPanel(detailEl) {
    if (!productPanel || !productPanelContent) return;
    productPanelContent.innerHTML = '';
    productPanelContent.appendChild(detailEl.cloneNode(true));
    if (productPanelSheet) productPanelSheet.scrollTop = 0;
    wireProductDetail(productPanelContent, closeProductPanel);
    productPanel.classList.add('abv-open');
  }

  if (productPanelClose) productPanelClose.addEventListener('click', closeProductPanel);
  if (productPanelBackdrop) productPanelBackdrop.addEventListener('click', closeProductPanel);

  // ---- Desktop side panel (persistent: product list, or a selected
  // product's full detail, for whichever slide is currently active) ----
  // The panel's own "fixed height matching the video, then scroll" relies
  // on .abv-reels-shell (height:auto, capped by max-height) + percentage
  // heights on the panel underneath it — a flex/height interaction that
  // different browser engines have been known to resolve inconsistently
  // (auto-height flex containers with max-height, combined with
  // percentage-height descendants, is a genuinely ambiguous area of the
  // flexbox spec). Rather than fight that ambiguity in CSS, this measures
  // the video pane's actual rendered height directly and pins the panel
  // to that exact pixel value — deterministic in every browser/theme,
  // since it no longer depends on how any given engine resolves the
  // auto/percentage chain.
  function syncDesktopPanelHeight() {
    if (!desktopPanel) return;
    var videopane = reelsOverlay ? reelsOverlay.querySelector('.abv-reels-videopane') : null;
    if (!videopane) return;
    var h = videopane.getBoundingClientRect().height;
    if (h) desktopPanel.style.height = h + 'px';
  }

  function renderDesktopPanel(slide, initialIndex) {
    if (!desktopPanel || !desktopPanelList || !desktopPanelDetail) return;
    var miniNodes = slide._miniNodes || [];
    var detailNodes = slide._detailNodes || [];

    if (desktopPanelDetail._galleryObserver) {
      desktopPanelDetail._galleryObserver.disconnect();
      desktopPanelDetail._galleryObserver = null;
    }
    desktopPanelList.innerHTML = '';
    desktopPanelDetail.innerHTML = '';

    if (!detailNodes.length) {
      desktopPanel.hidden = true;
      return;
    }
    desktopPanel.hidden = false;
    syncDesktopPanelHeight();

    function showDetail(idx) {
      desktopPanelDetail.innerHTML = '';
      desktopPanelDetail.appendChild(detailNodes[idx].cloneNode(true));
      if (miniNodes.length > 1) {
        var backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'abv-desktop-panel__back';
        backBtn.textContent = '← Back to products';
        backBtn.addEventListener('click', showList);
        desktopPanelDetail.insertBefore(backBtn, desktopPanelDetail.firstChild);
      }
      wireProductDetail(desktopPanelDetail);
      desktopPanelDetail.hidden = false;
      desktopPanelList.hidden = true;
    }
    function showList() {
      desktopPanelDetail.hidden = true;
      desktopPanelList.hidden = false;
    }
    if (miniNodes.length <= 1) {
      showDetail(0);
      return;
    }
    miniNodes.forEach(function (node, idx) {
      var clone = node.cloneNode(true);
      clone.addEventListener('click', function () { showDetail(idx); });
      var btn = clone.querySelector('[data-reel-shopnow]');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          showDetail(idx);
        });
      }
      desktopPanelList.appendChild(clone);
    });
    // Card product preview (outside the reel) opens straight to a specific
    // product's detail instead of the list — same showDetail used by the
    // list clicks/Shop Now above, just invoked immediately when requested.
    if (typeof initialIndex === 'number' && detailNodes[initialIndex]) {
      showDetail(initialIndex);
    } else {
      showList();
    }
  }

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function showReelControls(slide) {
    var ctr = slide._controls;
    if (!ctr) return;
    ctr.playBtn.classList.add('abv-visible');
    ctr.progressWrap.classList.add('abv-visible');
    if (ctr.fadeTimer) clearTimeout(ctr.fadeTimer);
    ctr.fadeTimer = setTimeout(function () {
      ctr.playBtn.classList.remove('abv-visible');
      ctr.progressWrap.classList.remove('abv-visible');
    }, 3500);
  }

  function updateReelPlayIcon(slide, video) {
    var ctr = slide._controls;
    if (!ctr) return;
    ctr.playBtn.textContent = video.paused ? '▶' : '❚❚';
  }

  function setupReelSlideControls(slide, video) {
    var ctr = slide._controls;
    var seeking = false;

    video.addEventListener('timeupdate', function () {
      if (video.duration) ctr.progressFill.style.width = (video.currentTime / video.duration * 100) + '%';
    });
    video.addEventListener('play', function () { updateReelPlayIcon(slide, video); });
    video.addEventListener('pause', function () { updateReelPlayIcon(slide, video); });

    function seekFromEvent(e) {
      var rect = ctr.progressBar.getBoundingClientRect();
      var ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
      if (video.duration) {
        video.currentTime = ratio * video.duration;
        ctr.progressFill.style.width = (ratio * 100) + '%';
      }
    }
    ctr.progressBar.addEventListener('pointerdown', function (e) {
      seeking = true;
      showReelControls(slide);
      seekFromEvent(e);
      e.stopPropagation();
      if (ctr.progressBar.setPointerCapture) {
        try { ctr.progressBar.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });
    ctr.progressBar.addEventListener('pointermove', function (e) {
      if (!seeking) return;
      seekFromEvent(e);
      showReelControls(slide);
    });
    ctr.progressBar.addEventListener('pointerup', function (e) {
      seeking = false;
      e.stopPropagation();
    });
    ctr.progressBar.addEventListener('click', function (e) {
      e.stopPropagation();
    });
    slide.addEventListener('click', function () {
      if (seeking) return;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      showReelControls(slide);
    });
  }

  // Builds the swipeable mini-product-card carousel shown at the bottom of
  // a mobile reel slide. Works the same whether there's 1 product (single
  // card, fills the row) or several (each card sized <100% via CSS so the
  // next one's edge peeks in — that peek is the "more products" signal,
  // replacing the old dot indicator).
  function buildProductCarousel(miniNodes, onShopNow) {
    var wrap = document.createElement('div');
    wrap.className = 'abv-product-carousel';

    var track = document.createElement('div');
    track.className = 'abv-product-carousel__track';
    miniNodes.forEach(function (node) {
      track.appendChild(node.cloneNode(true));
    });
    wrap.appendChild(track);

    track.querySelectorAll('[data-reel-shopnow]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        onShopNow(Number(btn.getAttribute('data-index')));
      });
    });
    return wrap;
  }

  function shareCurrentSlide() {
    // Tags the link with this specific video's stable block id so whoever
    // opens it lands on the same video, not just the same page (see the
    // auto-open-from-URL check near the bottom of this script).
    var shareUrl = window.location.href;
    var activeCard = videoCards[reelsActiveIndex];
    var videoId = activeCard ? activeCard.getAttribute('data-video-id') : '';
    if (videoId) {
      try {
        var urlObj = new URL(shareUrl);
        urlObj.searchParams.set('abv_video', videoId);
        shareUrl = urlObj.toString();
      } catch (err) {}
    }
    if (navigator.share) {
      navigator.share({ title: document.title, url: shareUrl }).catch(function () {});
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl).then(function () {
        showProductToast('Link copied!', false);
      }).catch(function () {});
    }
  }

  function buildReelSlide(card, index) {
    var cardVideo = card.querySelector('.video-card__video');
    attachCardVideoSource(cardVideo);
    var src = cardVideo.querySelector('source').getAttribute('src');
    var poster = cardVideo.getAttribute('poster');

    var slide = document.createElement('div');
    slide.className = 'abv-reels-slide';
    slide.dataset.index = index;

    var video = document.createElement('video');
    video.loop = true;
    video.playsInline = true;
    video.preload = 'none';
    if (poster) video.poster = poster;
    video.dataset.src = src;

    var playBtn = document.createElement('div');
    playBtn.className = 'abv-reels-playbtn';
    playBtn.textContent = '▶';

    var progressWrap = document.createElement('div');
    progressWrap.className = 'abv-reels-progress-wrap';
    var progressBar = document.createElement('div');
    progressBar.className = 'abv-reels-progress-bar';
    var progressFill = document.createElement('div');
    progressFill.className = 'abv-reels-progress-fill';
    progressBar.appendChild(progressFill);
    progressWrap.appendChild(progressBar);

    var actions = document.createElement('div');
    actions.className = 'abv-reels-actions';

    var shareBtn = document.createElement('button');
    shareBtn.type = 'button';
    shareBtn.className = 'abv-reels-share';
    shareBtn.setAttribute('aria-label', 'Share');
    shareBtn.innerHTML =
      '<svg class="abv-reels-share__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M2 21l21-9L2 3v7l15 2-15 2z"></path></svg>' +
      '<span class="abv-reels-share__label">Share</span>';
    shareBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      shareCurrentSlide();
    });
    var cartBtn = document.createElement('button');
    cartBtn.type = 'button';
    cartBtn.className = 'abv-reels-cartbtn';
    cartBtn.setAttribute('aria-label', 'Open cart');
    cartBtn.innerHTML =
      '<svg class="abv-reels-cartbtn__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4V3a1 1 0 011-1h8a1 1 0 011 1v1h3a1 1 0 011 1v15a2 2 0 01-2 2H5a2 2 0 01-2-2V5a1 1 0 011-1h3zm2 0h6V4H9zm-4 2v14h14V6H5z"></path></svg>' +
      '<span class="abv-cart-count" data-cart-count hidden>0</span>' +
      '<span class="abv-reels-cartbtn__label">Cart</span>';
    cartBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      openCartPanel();
    });
    actions.appendChild(shareBtn);
    actions.appendChild(cartBtn);

    slide.appendChild(video);
    slide.appendChild(playBtn);
    slide.appendChild(progressWrap);
    slide.appendChild(actions);

    var productDataTemplate = card.querySelector('[data-reel-product-data]');
    var miniNodes = [];
    var detailNodes = [];
    if (productDataTemplate) {
      miniNodes = Array.prototype.slice.call(productDataTemplate.content.querySelectorAll('[data-product-mini]'));
      detailNodes = Array.prototype.slice.call(productDataTemplate.content.querySelectorAll('[data-product-detail]'));
    }
    // Stashed on the slide so the desktop side panel can read them when
    // this slide becomes active (see renderDesktopPanel / reelsActiveObserver).
    slide._miniNodes = miniNodes;
    slide._detailNodes = detailNodes;

    if (miniNodes.length && !reelsDesktopMode) {
      slide.appendChild(buildProductCarousel(miniNodes, function (idx) {
        openProductPanel(detailNodes[idx]);
      }));
    }
    slide._controls = {
      playBtn: playBtn,
      progressWrap: progressWrap,
      progressBar: progressBar,
      progressFill: progressFill,
      fadeTimer: null
    };
    setupReelSlideControls(slide, video);

    return slide;
  }

  function attachReelSource(video) {
    if (!video || !video.dataset.src) return;
    var source = document.createElement('source');
    source.src = video.dataset.src;
    source.type = 'video/mp4';
    video.appendChild(source);
    delete video.dataset.src;
    video.preload = 'metadata';
    video.load();
  }

  function playReelSlide(slide) {
    var video = slide && slide.querySelector('video');
    if (!video) return;
    attachReelSource(video);
    video.muted = false;
    var p = video.play();
    if (p && p.catch) {
      p.catch(function () {
        video.muted = true;
        video.play();
      });
    }
    updateReelPlayIcon(slide, video);
    showReelControls(slide);
  }

  function pauseReelSlide(slide) {
    var video = slide && slide.querySelector('video');
    if (video) video.pause();
    var ctr = slide && slide._controls;
    if (ctr && ctr.fadeTimer) {
      clearTimeout(ctr.fadeTimer);
      ctr.fadeTimer = null;
    }
  }

  function goToReelIndex(idx) {
    if (!reelsTrack) return;
    var slides = reelsTrack.querySelectorAll('.abv-reels-slide');
    if (idx < 0 || idx >= slides.length) return;
    slides[idx].scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function openReels(startIndex, initialProductIndex) {
    if (!reelsOverlay || !reelsTrack) return;
    suspendCardPreviews();
    // Slides (and their cart buttons/badges) are rebuilt from scratch on
    // every open, so the freshly created badges need the current count.
    refreshCartCount();
    reelsDesktopMode = !isMobile();

    reelsTrack.innerHTML = '';
    videoCards.forEach(function (card, i) {
      reelsTrack.appendChild(buildReelSlide(card, i));
    });
    var slides = reelsTrack.querySelectorAll('.abv-reels-slide');

    reelsPrevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    reelsOverlay.hidden = false;

    var target = slides[startIndex];
    if (target) {
      // Jump straight to the tapped video, no animation.
      reelsTrack.scrollTop = target.offsetTop;
    }
    reelsActiveIndex = startIndex;
    if (target) playReelSlide(target);

    var hasInitialProduct = typeof initialProductIndex === 'number';
    if (target && reelsDesktopMode) renderDesktopPanel(target, hasInitialProduct ? initialProductIndex : undefined);
    // Mobile: card product preview opens straight to that product's detail
    // sheet, same sheet the mobile carousel's own Shop Now button opens —
    // this is the only new touch point, nothing about that carousel changes.
    if (target && !reelsDesktopMode && hasInitialProduct && target._detailNodes && target._detailNodes[initialProductIndex]) {
      openProductPanel(target._detailNodes[initialProductIndex]);
    }
    // Make the phone's hardware/gesture back button close the reel
    // instead of navigating away from the page.
    if (!reelsHistoryPushed) {
      history.pushState({ abvReelsOpen: true }, '', location.href);
      reelsHistoryPushed = true;
    }
    [startIndex - 1, startIndex + 1].forEach(function (i) {
      if (slides[i]) attachReelSource(slides[i].querySelector('video'));
    });
    reelsSourceObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) attachReelSource(entry.target.querySelector('video'));
      });
    }, { root: reelsTrack, rootMargin: '150% 0px' });
    slides.forEach(function (slide) { reelsSourceObserver.observe(slide); });

    reelsActiveObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
          var index = Number(entry.target.dataset.index);
          if (reelsActiveIndex !== index) {
            pauseReelSlide(slides[reelsActiveIndex]);
            reelsActiveIndex = index;
            playReelSlide(entry.target);
            if (reelsDesktopMode) renderDesktopPanel(entry.target);
          }
        }
      });
    }, { root: reelsTrack, threshold: [0, 0.6, 1] });
    slides.forEach(function (slide) { reelsActiveObserver.observe(slide); });
  }

  function closeReels(fromPopstate) {
    if (!reelsOverlay || reelsOverlay.hidden) return;

    // Reset so the cart panel never stays open behind a closed reel and
    // reappear unexpectedly on the next open.
    if (cartPanel) cartPanel.hidden = true;
    cartVideoWasPlaying = false;

    reelsOverlay.hidden = true;
    document.body.style.overflow = reelsPrevBodyOverflow;

    if (reelsSourceObserver) { reelsSourceObserver.disconnect(); reelsSourceObserver = null; }
    if (reelsActiveObserver) { reelsActiveObserver.disconnect(); reelsActiveObserver = null; }
    if (desktopPanelDetail && desktopPanelDetail._galleryObserver) {
      desktopPanelDetail._galleryObserver.disconnect();
      desktopPanelDetail._galleryObserver = null;
    }
    if (desktopPanelList) desktopPanelList.innerHTML = '';
    if (desktopPanelDetail) desktopPanelDetail.innerHTML = '';
    if (desktopPanel) desktopPanel.hidden = true;

    reelsTrack.innerHTML = ''; // stops playback and frees memory
    reelsActiveIndex = -1;

    resumeCardPreviews();

    // Consume the history entry we pushed on open, unless this close was
    // itself triggered by the back button (that entry is already gone).
    if (reelsHistoryPushed) {
      reelsHistoryPushed = false;
      if (!fromPopstate) history.back();
    }
  }

  if (reelsPrevBtn) reelsPrevBtn.addEventListener('click', function () { goToReelIndex(reelsActiveIndex - 1); });
  if (reelsNextBtn) reelsNextBtn.addEventListener('click', function () { goToReelIndex(reelsActiveIndex + 1); });

  // Desktop modal: clicking the dimmed backdrop (not the shell itself)
  // closes it, and Escape closes it from either device.
  if (reelsOverlay) {
    reelsOverlay.addEventListener('click', function (e) {
      if (e.target === reelsOverlay) closeReels(false);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // Innermost layer first, so Escape dismisses only the topmost thing
    // rather than tearing down the whole reel from underneath it.
    if (abvLightboxEl && !abvLightboxEl.hidden) {
      closeImageLightbox();
      return;
    }
    if (cartPanel && !cartPanel.hidden) {
      closeCartPanel();
      return;
    }
    if (reelsOverlay && !reelsOverlay.hidden) closeReels(false);
  });

  if (reelsClose) reelsClose.addEventListener('click', function () { closeReels(false); });

  window.addEventListener('popstate', function () {
    closeReels(true);
  });

  window.addEventListener('resize', function () {
    if (reelsDesktopMode && reelsOverlay && !reelsOverlay.hidden) syncDesktopPanelHeight();
  });

  function handleCardActivate(card) {
    // Opens on both mobile (full-screen reel) and desktop (centered modal
    // with the video on the left and the product panel docked on the
    // right) — the CSS media query and reelsDesktopMode flag handle the
    // presentation difference, this entry point doesn't need to branch.
    if (reelsOverlay && reelsTrack) {
      var reelIndex = videoCards.indexOf(card);
      if (reelIndex !== -1) {
        try {
          openReels(reelIndex);
          return;
        } catch (err) {
          if (window.console) console.error('Reels failed to open, falling back to inline play:', err);
          // openReels suspends card previews as its first step — un-suspend
          // so previews keep working after falling back to inline play.
          resumeCardPreviews();
        }
      }
    }
    toggleCardVideo(card);
  }

  cards.forEach(function (card) {
    var icon = card.querySelector('[data-play-icon]');

    card.addEventListener('click', function (e) {
      if (icon && icon.contains(e.target)) return;
      handleCardActivate(card);
    });
    if (icon) {
      icon.addEventListener('click', function (e) {
        e.stopPropagation();
        handleCardActivate(card);
      });
      icon.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          handleCardActivate(card);
        }
      });
    }
  });

  // Pause video when section goes out of view
  if (hasIO) {
    var visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) stopCurrentVideo();
      });
    }, { threshold: 0.2 });

    visibilityObserver.observe(sectionEl);
  }

  // Card thumbnail auto-preview: silently loop the first few seconds of each
  // card's video only while that specific card is visible on screen. Kept
  // fully separate from currentVideo/toggleCardVideo (the click-to-play-with-
  // sound state) and from the reels overlay (which uses its own cloned video
  // elements). Tapping a card still opens the full reel as before.
  //
  // While the reels overlay is open, previews are suspended (see
  // suspendCardPreviews/resumeCardPreviews, called from openReels/closeReels):
  // IntersectionObserver only measures viewport geometry, not occlusion, so
  // without this the cards behind the overlay would keep decoding video the
  // whole time the customer is watching a reel.
  if (!hasIO) {
    cards.forEach(function (card) {
      applyCardPoster(card.querySelector('.video-card__video'));
    });
  }

  if (hasIO) {
    var PREVIEW_LOOP_SECONDS = 4;

    // ---- Staggered preview start ----------------------------------------
    // The cards sit in ONE horizontal row, so vertically they all cross the
    // same threshold inside the SAME observer callback. Left alone, that
    // hands the browser N x video.load() (network + demux + decoder set-up)
    // and then N x .play() inside a single frame, right as the section
    // enters the viewport — one long main-thread task landing on the
    // scroll, felt as a heavy / sticky spot just before this section.
    //
    // The BURST is the problem, not the work: the same work released one
    // item at a time across frames is unnoticeable. So nothing here waits
    // for the scroll to stop — a card starts previewing as soon as it is
    // actually in view, mid-scroll included. The calls are only queued and
    // let out one per tick instead of all in one go.
    var LOAD_STAGGER_MS = 120; // heavy: network + demux + decoder set-up
    var PLAY_STAGGER_MS = 60;  // light: the source is already buffering

    // requestIdleCallback lets the browser slot the heavy load between
    // frames while a fast scroll is in flight; the timeout guarantees it
    // still runs promptly if the main thread never goes idle. Safari has
    // no rIC, so it falls back to a plain task.
    var runIdle = window.requestIdleCallback
      ? function (fn) { window.requestIdleCallback(fn, { timeout: 300 }); }
      : function (fn) { setTimeout(fn, 0); };

    var loadQueue = [];
    var loadTimer = null;
    var playQueue = [];
    var playTimer = null;

    function pumpLoadQueue() {
      if (loadTimer || !loadQueue.length) return;
      loadTimer = setTimeout(function () {
        loadTimer = null;
        runIdle(function () {
          var video = loadQueue.shift();
          if (video) attachCardVideoSource(video);
          pumpLoadQueue();
        });
      }, LOAD_STAGGER_MS);
    }
    function startPreview(card) {
      // Re-checked at release time, not at queue time: by now the card may
      // have scrolled back out, or the reel may have opened over it.
      if (previewsSuspended) return;
      if (!card.hasAttribute('data-preview-visible')) return;
      var v = card.querySelector('.video-card__video');
      if (!v) return;
      // Never touch the one card the customer is playing WITH sound via the
      // inline fallback — everything else is preview-muted.
      if (v !== currentVideo) v.muted = true;
      if (!v.paused || !v.muted) return;
      // No-op once the source is on. Only does real work if this card came
      // into view before its turn in the load queue came up — it is on
      // screen now, so it jumps the queue.
      attachCardVideoSource(v);
      var previewPlay = v.play();
      if (previewPlay && previewPlay.catch) previewPlay.catch(function () {});
    }
    function pumpPlayQueue() {
      if (playTimer || !playQueue.length) return;
      playTimer = setTimeout(function () {
        playTimer = null;
        var card = playQueue.shift();
        if (card) startPreview(card);
        pumpPlayQueue();
      }, PLAY_STAGGER_MS);
    }
    // Loads a card's video source with a head start — well before it's
    // actually on screen — the same technique the reel already uses
    // (attachCardVideoSource/rootMargin) so buffering is underway by the
    // time the customer scrolls to it, instead of starting from zero at
    // the exact moment it becomes visible (which is what caused the
    // "poster sits there, video catches up late" delay).
    var previewLoadObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // .observe() fires once immediately with the card's starting state
        // — usually not yet within the rootMargin buffer — so this must be
        // gated on isIntersecting, otherwise every card's source would load
        // right away regardless of position, defeating the lazy-load.
        if (!entry.isIntersecting) return;
        var video = entry.target.querySelector('.video-card__video');
        if (!video) return;
        // Posters for the WHOLE row, not just this card: the cards sit in one
        // horizontal strip, so the ones off to the right never intersect
        // until swiped to, and a card sliding in without its poster is a
        // visible regression. One card being a viewport away is the cue.
        cards.forEach(function (c) {
          applyCardPoster(c.querySelector('.video-card__video'));
        });
        if (video.dataset.src) loadQueue.push(video);
        previewLoadObserver.unobserve(entry.target);
      });
      pumpLoadQueue();
    }, { rootMargin: '100% 0px' });

    // threshold 0.25 (was 0.5): a card starts previewing once a quarter of
    // it has come into view, rather than waiting to be half on screen, so
    // playback is already running by the time the customer is looking at
    // it. Queued rather than played inline — see pumpPlayQueue above.
    var previewObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var previewVideo = entry.target.querySelector('.video-card__video');
        if (!previewVideo) return;

        if (entry.isIntersecting) {
          // Remembered even while suspended, so resumeCardPreviews knows
          // which cards should start looping again when the reel closes.
          entry.target.setAttribute('data-preview-visible', 'true');
          if (!previewsSuspended) playQueue.push(entry.target);
        } else {
          entry.target.removeAttribute('data-preview-visible');
          // Immediate: pausing frees a decoder, so it only ever helps.
          previewVideo.pause();
        }
      });
      pumpPlayQueue();
    }, { threshold: 0.25 });

    cards.forEach(function (card) {
      var previewVideo = card.querySelector('.video-card__video');
      if (!previewVideo) return;

      previewVideo.addEventListener('timeupdate', function () {
        // muted check: the 4s loop must only govern the silent preview.
        // If the reel ever fails to open, toggleCardVideo plays this same
        // element inline WITH sound (muted = false) — that real playback
        // must be allowed to run past 4 seconds.
        if (previewVideo.muted && previewVideo.currentTime >= PREVIEW_LOOP_SECONDS) previewVideo.currentTime = 0;
      });
      previewLoadObserver.observe(card);
      previewObserver.observe(card);
    });
  }

  // Card product preview (outside the card, below it): tapping a mini card
  // opens that video's reel jumped straight to that product's detail.
  // Entirely separate elements/click targets from the reel's own product
  // list/Shop Now — nothing here is read by, or feeds into, that code.
  cards.forEach(function (card) {
    var previewBlock = card.parentElement && card.parentElement.querySelector('[data-card-product-preview]');
    if (!previewBlock) return;

    var reelIndex = videoCards.indexOf(card);
    if (reelIndex === -1) return;

    previewBlock.querySelectorAll('[data-preview-mini]').forEach(function (miniEl) {
      miniEl.addEventListener('click', function (e) {
        e.stopPropagation();
        var idx = Number(miniEl.getAttribute('data-index'));
        openReels(reelIndex, idx);
      });
    });
    // Active-dot tracking while swiping, mirroring the same behavior already
    // used by the in-reel mobile product carousel.
    var previewTrack = previewBlock.querySelector('[data-preview-track]');
    var previewDots = previewBlock.querySelectorAll('[data-preview-dots] .abv-product-carousel__dot');
    if (previewTrack && previewDots.length > 1 && hasIO) {
      var previewDotsObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            var idx = Array.prototype.indexOf.call(previewTrack.children, entry.target);
            previewDots.forEach(function (dot, i) { dot.classList.toggle('abv-active', i === idx); });
          }
        });
      }, { root: previewTrack, threshold: [0, 0.6, 1] });
      Array.prototype.forEach.call(previewTrack.children, function (child) { previewDotsObserver.observe(child); });
    }
  });

  // ---- Desktop scroll arrows for the card row ----
  // Purely a scroll control: it moves .video-scroll by one card per click and
  // nothing else. Card playback, previews and the reel overlay are untouched.
  var scrollTrack = sectionEl.querySelector('.video-scroll');
  var scrollPrevBtn = sectionEl.querySelector('[data-scroll-prev]');
  var scrollNextBtn = sectionEl.querySelector('[data-scroll-next]');

  function updateScrollArrows() {
    if (!scrollTrack || !scrollPrevBtn || !scrollNextBtn) return;
    // Buttons are display:none under 769px anyway, but keeping them [hidden]
    // there too means no stray focusable element in the mobile tab order.
    var maxScroll = scrollTrack.scrollWidth - scrollTrack.clientWidth;
    if (maxScroll <= 2 || window.innerWidth < 769) {
      scrollPrevBtn.hidden = true;
      scrollNextBtn.hidden = true;
      return;
    }
    scrollPrevBtn.hidden = scrollTrack.scrollLeft <= 2;
    scrollNextBtn.hidden = scrollTrack.scrollLeft >= maxScroll - 2;
  }

  if (scrollTrack && scrollPrevBtn && scrollNextBtn) {
    var scrollStep = function () {
      var firstCard = scrollTrack.querySelector('.video-card');
      var gap = parseInt(window.getComputedStyle(scrollTrack).columnGap, 10);
      if (isNaN(gap)) gap = 0;
      var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : scrollTrack.clientWidth * 0.8;
      return cardWidth + gap;
    };
    var scrollByStep = function (dir) {
      var left = scrollStep() * dir;
      if (scrollTrack.scrollBy) {
        scrollTrack.scrollBy({ left: left, behavior: 'smooth' });
      } else {
        scrollTrack.scrollLeft += left;
      }
    };
    scrollPrevBtn.addEventListener('click', function () { scrollByStep(-1); });
    scrollNextBtn.addEventListener('click', function () { scrollByStep(1); });
    scrollTrack.addEventListener('scroll', updateScrollArrows, { passive: true });
    window.addEventListener('resize', updateScrollArrows);
    // Late-loading posters/images can change scrollWidth after first paint.
    window.addEventListener('load', updateScrollArrows);
    updateScrollArrows();
  }

  // Shared-link deep linking: if the URL carries ?abv_video=<block id> (see
  // shareCurrentSlide), jump straight to that video's reel/modal on load.
  try {
    var sharedVideoId = new URLSearchParams(window.location.search).get('abv_video');
    if (sharedVideoId) {
      var sharedIndex = videoCards.findIndex(function (c) {
        return c.getAttribute('data-video-id') === sharedVideoId;
      });
      if (sharedIndex !== -1) openReels(sharedIndex);
    }
  } catch (err) {}
};

(function () {
  function abvInitAll() {
    var nodes = document.querySelectorAll('[data-abv-section]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-abv-init')) continue;
      nodes[i].setAttribute('data-abv-init', '1');
      abvShoppableVideoInit(nodes[i]);
    }
  }

  // The bundle is deferred, so the DOM is usually ready by the time this
  // runs; the readyState check covers the case where it is not.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', abvInitAll);
  } else {
    abvInitAll();
  }

  // Theme editor: adding or re-rendering the section produces a fresh
  // element with no data-abv-init, so it wires up while old nodes are
  // simply discarded with their listeners.
  document.addEventListener('shopify:section:load', abvInitAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
